/**
 * About page timeline: hovering (or focusing) an entry switches the page
 * background to that entry's theme. On touch screens the entry nearest the
 * middle of the screen drives the theme instead.
 * Markup: [data-apx] .apx-theme[data-theme] (backgrounds) + [data-theme].apx-entry / .apx-era-head (triggers)
 */
(() => {
  const init = (root) => {
    const themes = new Map([...root.querySelectorAll('.apx-theme')].map((el) => [el.dataset.theme, el]));
    const targets = [...root.querySelectorAll('.apx-entry[data-theme], .apx-era-head[data-theme]')];
    let active = null;
    let resetTimer = 0;

    const set = (name) => {
      clearTimeout(resetTimer);
      if (name === active) return;
      active = name;
      themes.forEach((el, key) => el.classList.toggle('is-active', key === name));
      targets.forEach((t) => t.classList.toggle('is-active', t.dataset.theme === name));
    };
    const clearSoon = () => {
      clearTimeout(resetTimer);
      resetTimer = setTimeout(() => set(null), 250);
    };

    root.setAttribute('data-ready', '');
    const canHover = window.matchMedia('(hover: hover)').matches;

    targets.forEach((t) => {
      t.addEventListener('focus', () => set(t.dataset.theme));
      t.addEventListener('blur', clearSoon);
      if (canHover) {
        t.addEventListener('pointerenter', () => set(t.dataset.theme));
        t.addEventListener('pointerleave', clearSoon);
      }
    });

    if (!canHover && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => entries.forEach((e) => { if (e.isIntersecting) set(e.target.dataset.theme); }),
        { rootMargin: '-42% 0px -42% 0px', threshold: 0 }
      );
      targets.forEach((t) => observer.observe(t));
    }
  };

  const start = () => document.querySelectorAll('[data-apx]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
